import Styles from './styles.module.css';
import 'firebase/auth'
import React from 'react';
import { useState } from 'react';
import DefaultTitle from '../../../package/title/index';
import ErrorMessage from '../../../package/error/index';
import DefaultInput1 from '../../../package/1-input/index';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { docData } from 'src/type';

type RecruitDocument = {
  documentId: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  document: docData;
  setDocument: React.Dispatch<React.SetStateAction<docData>>;
};

const RecruitDocument: React.FC<RecruitDocument> = ({ documentId, setChangeData, document, setDocument }) => {

  const [ errorMessage, setErrorMessage ] = useState('');
  const [ banner, setBanner ] = useState<boolean>(false);

  const check = (isCompleted: boolean) => {
    window.scrollTo(0, 0);
    setErrorMessage('');

    // 書類選択チェック
    if (
      document.document &&
      !document.resume &&
      !document.question &&
      !document.coordinate &&
      !document.otherDocument
    ) {
      return setErrorMessage('提出を求める書類を選択してください。');
    }

    // 質問チェック・その他書類チェック
    // 「応募時の書類提出」自体を求めない(document.document === false)場合、
    // 過去にオンにした質問・その他提出物の有無フラグが残っていても
    // 画面上は非表示になるため、書類提出を求める場合のみ検証する。
    if (document.document) {
      const questionError = validateList(
        document.question,
        document.questionCount,
        [document.question1, document.question2, document.question3],
        '質問'
      );
      if (questionError) return setErrorMessage(questionError);

      const otherError = validateList(
        document.otherDocument,
        document.otherDocumentCount,
        [document.otherDocument1, document.otherDocument2, document.otherDocument3],
        'その他の提出物'
      );
      if (otherError) return setErrorMessage(otherError);
    }

    save(isCompleted);
  };
  
  const validateList = (
    enabled: boolean,
    count: number,
    values: string[],
    label: string
  ): string => {
    if (!enabled) return '';

    if (count === 0) return `${label}の数を入力してください。`;

    for (let i = 0; i < count; i++) {
      if (!values[i]) {
        return `${i + 1}.${label}を入力してください。`;
      }
    }

    return '';
  };

  const [ uploading, setUploading ] = useState(false);

  async function save(e: boolean) {
    setUploading(true);
    
    const db = getFirestore();
    
    const dataToSend = {
      ...document,
      isCompleted: e,
      time: new Date(),
    };
    
    let ok = false;

    try {

      await updateDoc(doc(db, "recruits", documentId), { document: dataToSend });

      setChangeData(false);
      ok = true;
    } catch (error) {
      console.error("🔥 保存に失敗:", error);
      setErrorMessage('保存に失敗しました。時間をおいてもう一度お試しください。');
    } finally {
      setUploading(false);
      // 保存できたときだけ「保存しました」を出す(失敗時に出ていたバグの修正)。
      if (ok) {
        setBanner(true);
        setTimeout(() => { setBanner(false); }, 1500);
      }
    }
  }

  return (
    <>
    {errorMessage !== '' ? <ErrorMessage message={errorMessage} /> : <></> }
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>雇用情報</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check(true)}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      <DefaultTitle title={'サロン見学'} />
      <div className={Styles.toggle_row}>
        <div className={Styles.toggle_row_text}>
          <span className={Styles.toggle_row_title}>募集する</span>
        </div>
        <label className={Styles.switch}>
          <input
            type="checkbox"
            checked={document.visit === true}
            onChange={(e) => {setDocument(prev => ({...prev, visit: e.target.checked})); setChangeData(true);}}
          />
          <span className={Styles.switchTrack} />
        </label>
      </div>

      <DefaultTitle title={'応募時の書類提出'} />
      <div className={Styles.toggle_row}>
        <div className={Styles.toggle_row_text}>
          <span className={Styles.toggle_row_title}>書類を求める</span>
        </div>
        <label className={Styles.switch}>
          <input
            type="checkbox"
            checked={document.document === true}
            onChange={(e) => {setDocument(prev => ({...prev, document: e.target.checked})); setChangeData(true);}}
          />
          <span className={Styles.switchTrack} />
        </label>
      </div>

    </div>


    {document.document && (
    <div className={Styles.test_box}>

      <h5 className={Styles.store_title}>書類の有無</h5>

      <DefaultTitle title={'履歴書の有無'} />
      <div className={Styles.toggle_row}>
        <div className={Styles.toggle_row_text}>
          <span className={Styles.toggle_row_title}>提出を求める</span>
        </div>
        <label className={Styles.switch}>
          <input
            type="checkbox"
            checked={document.resume === true}
            onChange={(e) => {setDocument(prev => ({...prev, resume: e.target.checked})); setChangeData(true);}}
          />
          <span className={Styles.switchTrack} />
        </label>
      </div>

      <DefaultTitle title={'追加質問の有無'} />
      <div className={Styles.toggle_row}>
        <div className={Styles.toggle_row_text}>
          <span className={Styles.toggle_row_title}>回答を求める</span>
        </div>
        <label className={Styles.switch}>
          <input
            type="checkbox"
            checked={document.question === true}
            onChange={(e) => {setDocument(prev => ({...prev, question: e.target.checked})); setChangeData(true);}}
          />
          <span className={Styles.switchTrack} />
        </label>
      </div>

      <DefaultTitle title={'コーディネート写真の有無'} />
      <div className={Styles.toggle_row}>
        <div className={Styles.toggle_row_text}>
          <span className={Styles.toggle_row_title}>提出を求める</span>
        </div>
        <label className={Styles.switch}>
          <input
            type="checkbox"
            checked={document.coordinate === true}
            onChange={(e) => {setDocument(prev => ({...prev, coordinate: e.target.checked})); setChangeData(true);}}
          />
          <span className={Styles.switchTrack} />
        </label>
      </div>

      <DefaultTitle title={'その他の提出書類'} />
      <div className={Styles.toggle_row}>
        <div className={Styles.toggle_row_text}>
          <span className={Styles.toggle_row_title}>提出を求める</span>
        </div>
        <label className={Styles.switch}>
          <input
            type="checkbox"
            checked={document.otherDocument === true}
            onChange={(e) => {setDocument(prev => ({...prev, otherDocument: e.target.checked})); setChangeData(true);}}
          />
          <span className={Styles.switchTrack} />
        </label>
      </div>

    </div>
    )}

    {(document.question && document.document) && (
      <div className={Styles.test_box}>
        <h5 className={Styles.store_title}>追加質問</h5>

        <DefaultTitle title={'質問数'} />
        <select
          className={Styles.select}
          value={document.questionCount}
          onChange={(e) => {
            setDocument(prev => ({
              ...prev,
              questionCount: Number(e.target.value),
            }));
            setChangeData(true);
          }}
        >
          <option value={0}>未選択</option>
          {[1, 2, 3].map(n => (
            <option key={n} value={n}>{n}つ</option>
          ))}
        </select>

        {[1, 2, 3].map(i =>
          document.questionCount >= i ? (
            <DefaultInput1
              key={i}
              error={false}
              title={`${i}.質問`}
              length={20}
              place=""
              value={document[`question${i}` as keyof typeof document] as string}
              setValue={(val: string) => {
                setDocument(prev => ({
                  ...prev,
                  [`question${i}`]: val,
                }));
                setChangeData(true);
              }}
              desc={'　'}
              hint={{ title: "", desc: "" }}
            />
          ) : null
        )}
      </div>
    )}

    {(document.otherDocument && document.document) && (
      <div className={Styles.test_box}>
        <h5 className={Styles.store_title}>その他の提出物</h5>

        <DefaultTitle title={'その他の提出物の数'} />
        <select
          className={Styles.select}
          value={document.otherDocumentCount}
          onChange={(e) => {
            setDocument(prev => ({
              ...prev,
              otherDocumentCount: Number(e.target.value),
            }));
            setChangeData(true);
          }}
        >
          <option value={0}>未選択</option>
          {[1, 2, 3].map(n => (
            <option key={n} value={n}>{n}つ</option>
          ))}
        </select>

        {[1, 2, 3].map(i =>
          document.otherDocumentCount >= i ? (
            <DefaultInput1
              key={i}
              error={false}
              title={`${i}.提出書類`}
              length={20}
              place=""
              value={document[`otherDocument${i}` as keyof typeof document] as string}
              setValue={(val: string) => {
                setDocument(prev => ({
                  ...prev,
                  [`otherDocument${i}`]: val,
                }));
                setChangeData(true);
              }}
              desc={'　'}
              hint={{ title: "", desc: "" }}
            />
          ) : null
        )}
      </div>
    )}

    </>
  );
}

export default RecruitDocument;